import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import StorageIcon from '@mui/icons-material/Storage';
import hipladeTemplate from '../../common/template';
import { useDefaultStyles } from '../../common/styles/default';
import { LocalVideoManagementView } from '../components/LocalVideoManagementView';

function LocalVideoPage() {
  const classes = useDefaultStyles();

  return (
    <Box className={classes.container}>
      <Box mb={3} display="flex" alignItems="center" gap={1.5}>
        <StorageIcon color="primary" sx={{ fontSize: 36 }} />
        <Box>
          <Typography variant="h5" fontWeight={600}>
            Gestão de Vídeos Locais & Sincronização GCS
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Monitore o armazenamento local de vídeos de debriefing, sincronize com a nuvem e gerencie o espaço em disco.
          </Typography>
        </Box>
      </Box>

      <LocalVideoManagementView />
    </Box>
  );
}

export default hipladeTemplate(LocalVideoPage);
